function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import get from 'lodash/get';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Avatar from 'components/Avatar';
import Button from 'components/Form/Button';
import AscensiaLogo from 'svg/Ascensia-logo.svg';
import Account from 'modules/Account';
import messages from '../../../messages';
import styles from './PatientHeader.pcss';
var _React_PureComponent;
class PatientHeader extends (_React_PureComponent = React.PureComponent) {
    onDiscardTab() {
        window.close();
    }
    renderClinic() {
        const { name, logo } = get(this.props.activeClinicMembership, 'clinic', {});
        return /*#__PURE__*/ _jsxs("div", {
            className: "d-flex",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto pr-0",
                    children: /*#__PURE__*/ _jsx(Avatar, {
                        avatarImg: logo,
                        name: name,
                        className: styles.clinicLogo,
                        imgClassName: styles.clinicLogo__img,
                        initialsClassName: styles.clinicLogo__initials
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: styles.clinicLogo__label,
                        children: name
                    })
                })
            ]
        });
    }
    renderDiscard() {
        return /*#__PURE__*/ _jsx(Button, {
            styleModifier: "quaternary",
            labelMessage: Account.messages.buttons.discard,
            onClick: ()=>this.onDiscardTab()
        });
    }
    renderMeterInfo() {
        if (!this.props.meterSerialNumber) return null;
        return /*#__PURE__*/ _jsx("p", {
            className: "text--bold",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.headers.previewingDataFromMeter), {
                values: {
                    serialNumber: this.props.meterSerialNumber
                }
            }))
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "d-flex align-items-center justify-content-between w-100",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.element,
                            children: /*#__PURE__*/ _jsx(AscensiaLogo, {
                                className: styles.ascensiaLogo
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.element,
                            children: this.renderClinic()
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: cn(styles.header__rightSide, 'd-flex align-items-center'),
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.element,
                            children: this.renderMeterInfo()
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: cn(styles.element, 'mr-0'),
                            children: this.renderDiscard()
                        })
                    ]
                })
            ]
        });
    }
}
_define_property(PatientHeader, "propTypes", {
    // Explicit props
    activeClinicMembership: Account.shapes.clinicMembership,
    meterSerialNumber: PropTypes.string,
    onSaveClick: PropTypes.func
});
export default withStyles(styles)(PatientHeader);
